(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["category-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.LoadSwiper === 'undefined') return;

    window.LoadSwiper.then((swiperModule) => {
      if (!swiperModule || !swiperModule.Swiper) return;

      const { Swiper, Navigation } = swiperModule;
      const sliders = document.querySelectorAll('.category-slider--block__swiper');
      sliders.forEach((slider) => {
        const nextBtn = slider.querySelector('.category-slider--block__next');
        const prevBtn = slider.querySelector('.category-slider--block__prev');
        const nav = slider.querySelector('.category-slider--block__navigation');
        const slides = slider.querySelectorAll('.category-slider--block__slide');
        const isAnimated = slider.classList.contains('animation--list-slider');
        const wrapper = slider.querySelector('.swiper-wrapper');

        const swiperOptions = {
          modules: [Navigation],
          slidesPerView: 'auto',
          spaceBetween: 12,
          grabCursor: true,
          watchOverflow: true,
          watchSlidesProgress: true,
          loop: false,
          navigation: { nextEl: nextBtn, prevEl: prevBtn },
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          breakpoints: {
            769: {
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 40,
              spaceBetween: 20,
            },
          },
        };

        if (isAnimated) {
          // Mirror delayOffset() from ba-theme.js: controls first, then each slide.
          let delayCounter = 0;
          if (nav) nav.style.setProperty('--delay-offset-multiplier', delayCounter++);
          slides.forEach((slide) => slide.style.setProperty('--delay-offset-multiplier', delayCounter++));

          // Mirror intersectionWatcher() from ba-theme.js, but start it only after
          // Swiper's on.init so the layout is correct before the fade-in plays.
          const observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                slider.classList.add('is-visible');
                observer.disconnect();
              }
            },
            { threshold: 0 }
          );

          swiperOptions.on = {
            init() {
              observer.observe(slider);
            },
          };
        }

        new Swiper(slider, swiperOptions);
      });
    }).catch((err) => console.error('Swiper Chunk konnte nicht geladen werden:', err));
  });
  } catch(e) { console.error(e); }
})();

})();
